import axios from 'axios';
import globals from "../config/appconfig";

export default class StatoInvioPremalServices {

    static urlGetFlussiSegnalazioni = globals["app-url-backend-premal"] + "/letturaFlussiSegnalazioni"
    static urlGetExportFlussiSegnalazioni = globals["app-url-backend-premal"] + "/downloadFlussiSegnalazioni"
    static urlGetFileScarto = globals["app-url-backend-premal"] + "/downloadFileScarto"
    static urlDeleteRecord = globals["app-url-backend-premal"] + "/"

    static getFlussiSegnalazioni(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlGetFlussiSegnalazioni + querystring)
    }

    static getExportFlussiSegnalazioni(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlGetExportFlussiSegnalazioni + querystring)
    }

    static getFileScarto(params) {

        return axios.get(this.urlGetFileScarto + "?idUpload=" + params)
    }

    static deleteRecord(id) {

        return axios.delete(this.urlDeleteRecord + id)
    }

}